import { CheckCircleTwoTone } from '@ant-design/icons';
import { Button, message, Modal, Spin } from 'antd';
import React, { useEffect, useState } from 'react';

import useTable from '../../components/Template/TableTemplate';
import { fetchAPI } from '../../utils/api';

const spanStyleObject: React.CSSProperties = {
  fontSize: 12,
  transform: 'translateY(-2px)',
  whiteSpace: 'break-spaces',
};
const SearchAmazonProduct = ({
  quantity = 1,
  disable = false,
  defaultValue = null,
  onChange = value => {},
  complete_data = false,
  address = '',
}) => {
  const [loading, setLoading] = useState(false);
  const [labelButton, setLabelButton] = useState('Select Amazon Product');
  const getAmazonProductInfo = async extId => {
    try {
      setLoading(true);
      const res = await fetchAPI(`amazon-api/product-detail`, {
        method: 'POST',
        payload: {
          external_id: extId,
        },
      });
      setLabelButton(
        `[${res.external_id}] ${res.name} (${res.price_currency} ${res.price})`
      );
    } catch (error) {
      setLabelButton('Select Amazon Product');
      message.error(`Cannot read Amazon Product info: ${error}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (defaultValue) {
      getAmazonProductInfo(defaultValue);
    } else {
      setLabelButton('Select Amazon Product');
    }
  }, [defaultValue]); // eslint-disable-line

  useEffect(() => {
    toggleLoad();
  }, [quantity, address]); // eslint-disable-line
  // eslint-disable-next-line
  const [table, toggleLoad] = useTable({
    updateQueryParams: false,
    useSearchVCard: false,
    useFilterCreatedBy: false,
    useInternalPurchase: false,
    paginationPosition: 'bottom',
    showDateRange: false,
    showDownload: false,
    showSearch: true,
    url: 'amazon-api/product-search',
    method: 'POST',
    columns: [
      {
        title: 'Actions',
        render: record => (
          <Button
            shape="circle"
            icon={<CheckCircleTwoTone twoToneColor="#52c41a" />}
            onClick={() => {
              setLabelButton(
                `[${record.external_id}] ${record.name} (${record.price_currency} ${record.price})`
              );
              onChange(complete_data ? record : record.external_id);
              setOpen(false);
            }}
          />
        ),
      },
      {
        title: 'External ID',
        key: 'external_id',
        dataIndex: 'external_id',
      },
      {
        title: 'Name',
        key: 'name',
        dataIndex: 'name',
      },
      {
        title: 'Price (JPY)',
        key: 'price',
        dataIndex: 'price',
      },
      {
        title: 'Stock',
        key: 'stock',
        dataIndex: 'stock',
      },
    ],
  });
  const [open, setOpen] = useState(false);

  return (
    <>
      {!disable ? (
        <Spin spinning={loading}>
          <Button
            style={{ height: 'auto' }}
            type="primary"
            onClick={() => setOpen(true)}
          >
            <span style={spanStyleObject}>{labelButton}</span>
          </Button>
        </Spin>
      ) : (
        <span style={spanStyleObject}>{labelButton}</span>
      )}
      <Modal
        title="Select Amazon Product"
        centered
        visible={open}
        width={'90%'}
        onCancel={() => setOpen(false)}
        footer={
          <button onClick={() => setOpen(false)} style={{ cursor: 'pointer' }}>
            Cancel
          </button>
        }
      >
        {table}
      </Modal>
    </>
  );
};

export default SearchAmazonProduct;
